import { render, staticRenderFns } from "./settlementsTransfer.vue?vue&type=template&id=60462d45"
import script from "./settlementsTransfer.vue?vue&type=script&lang=js"
export * from "./settlementsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports